'use client';
import styled, { css } from 'styled-components';

export const StyledImageDropdown = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.background.base};
  border: 0.5px solid #d5d4d4;
  border-radius: ${props => props.theme.spacing(2)};
  overflow: hidden;
  width: 100%;

  @media ${props => props.theme.mobileS} {
    width: 358px;
  }

  @media ${props => props.theme.tablet} {
    width: 490px;
  }
`;

export const DropdownContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${props => props.theme.spacing(1)};
  flex: 1;
  min-width: 0;
  margin-right: ${props => props.theme.spacing(2)};
`;

export const SelectionRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(2)};
`;

export const ContentHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: ${props => props.theme.spacing(1)};
`;

export const HeaderText = styled.p`
  color: ${props => props.theme.colors.text.primary};
  ${props => props.theme.typography.bodyBold}
`;

export const HelperText = styled.p`
  color: ${props => props.theme.colors.text.tertiary};
  ${props => props.theme.typography.body}
`;

export const SelectedText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => props.theme.colors.text.primary};
  ${props => props.theme.typography.button}
`;

export const DropdownButton = styled.div`
  cursor: pointer;
`;

export const IconContainer = styled.div``;

export const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  min-height: 108px;
  padding: ${props => props.theme.spacing(4, 4, 6)};
  cursor: pointer;
  background-color: transparent;
`;

export const DropdownMenu = styled.div`
  width: 100%;
  background-color: ${props => props.theme.colors.background.base};
  max-height: ${props => (props.$isOpen ? '400px' : '0')};
  opacity: ${props => (props.$isOpen ? '1' : '0')};
  padding-bottom: ${props => (props.$isOpen ? props.theme.spacing(6) : '0')};
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out,
    padding-bottom 0.3s ease-in-out;
  overflow-y: ${props => (props.$isOpen ? 'auto' : 'hidden')};
`;

export const StyledDropdownImageItem = styled.div`
  width: 100%;
  transition: background-color 0.2s ease;

  ${props =>
    props.$disabled &&
    !props.$isAllergen &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}

  ${props =>
    props.$isAllergen &&
    css`
      pointer-events: none;

      & ${ContentImage} {
        opacity: 0.4;
        filter: grayscale(100%);
      }

      & ${ContentText} {
        opacity: 0.5;
        color: ${props.theme.colors.text.tertiary};
      }
    `}

  &:hover {
    background-color: ${props =>
      !props.$disabled && props.theme.colors.background.lightest};
  }
`;

export const DropdownItemContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${props => props.theme.spacing(1)};
  padding: ${props => props.theme.spacing(2, 4, 2)};
  cursor: pointer;
`;

export const ContentImage = styled.div`
  width: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  transition: opacity 0.2s ease, filter 0.2s ease;
`;

export const ContentTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  min-width: 0;
`;

export const ContentText = styled.div`
  text-align: left;
  color: ${props => props.theme.colors.text.primary};
  ${props => props.theme.typography.button}
  transition: opacity 0.2s ease, color 0.2s ease;
`;

export const ContentLink = styled.div`
  ${props => props.theme.typography.body}
  color: ${({ theme }) => theme.colors.hero.plum};
  margin-top: ${props => props.theme.spacing(0.5)};
  display: flex;
  align-items: center;
`;

export const RedDotContainer = styled.div``;

export const RedDot = styled.span`
  display: inline-block;
  width: ${props => props.theme.spacing(1.5)};
  height: ${props => props.theme.spacing(1.5)};
  background-color: ${props => props.theme.colors.status.errorPrimary};
  border-radius: 50%;
  margin-right: ${props => props.theme.spacing(1)};
  margin-bottom: ${props => props.theme.spacing(0.5)};
  flex-shrink: 0;
`;

export const AllergyWarningText = styled.div`
  display: flex;
  align-items: baseline;
  text-align: left;
  color: ${props => props.theme.colors.text.secondary};
  ${props => props.theme.typography.body};

  @media ${props => props.theme.tablet} {
    align-items: center;
  }
`;

export const LimitWarningText = styled.div`
  text-align: left;
  color: ${props => props.theme.colors.text.tertiary};
  ${props => props.theme.typography.body};
`;

export const NoSelectionText = styled.div`
  color: ${props => props.theme.colors.status.warningPrimary};
  ${props => props.theme.typography.button}
`;

export const ImageStackContainer = styled.div`
  display: flex;
  align-items: center;
  height: ${props => props.theme.spacing(12)};
  @media ${props => props.theme.mobileS} {
    max-width: 105px;
  }

  @media ${props => props.theme.mobileL} {
    max-width: unset;
  }
`;

export const StackedImageWrapper = styled.div`
  height: ${props => props.theme.spacing(12)};
  position: relative;
  margin-left: ${props => (props.$index > 0 ? props.theme.spacing(-10) : 0)};
  z-index: ${props => props.$index};
  transition: margin 0.2s ease;
`;
